import { Outlet } from 'react-router-dom';
import { useMaintenanceSection } from '@/features/maintenance/hooks/useMaintenance';
import { SectionMaintenance } from '@/features/maintenance/components/SectionMaintenance';
import type { MaintenanceSectionKey } from '@/features/maintenance/types/maintenance.types';

/**
 * Route-layout gate for one maintainable section. Nest the section's routes
 * under `<Route element={<SectionGate section="appointments" />}>`: while that
 * section is in maintenance the block view renders in place of the pages.
 */
export function SectionGate({ section }: { section: Exclude<MaintenanceSectionKey, 'all'> }) {
  const status = useMaintenanceSection(section);

  if (status.active) return <SectionMaintenance sectionKey={section} section={status} />;

  return <Outlet />;
}
